import { tableWidth, title } from "./report-template-setting";
import { format } from "date-fns";

const ReportTemplateHeader = (props) => {
  const { data_product } = props.reportParam;

  return (
    <div className={`col-start-start w-full ${tableWidth}`}>
      <div id="report-title" className="bg-zinc-500 p-3 w-full tracking-wide">
        <h1 className="text-white font-semibold">{title}</h1>
      </div>
      <div
        id="report-first-page"
        className="row-between-start text-sm py-4 w-full px-2"
      >
        <div className="col-start-start gap-1">
          <div className="col-start-start gap-2">
            <span className=""> Package Name: </span>
            <div className="col-start-start">
              {data_product && data_product.length > 0
                ? data_product.map((item) => {
                    return (
                      <div className="row-start-center gap-2" key={item.id}>
                        <i className="pi pi-circle-fill text-[0.5rem] text-slate-500"></i>
                        <span className="font-semibold ">{item.name}</span>
                      </div>
                    );
                  })
                : "-"}
            </div>
          </div>
        </div>
        <div className="col-start-start gap-1">
          <div className="row-start-center gap-2">
            <span className="w-[6rem] text-right"> Tanggal Print: </span>
            <span className="font-semibold">
              {format(new Date(), "dd MMM yyyy  HH:mm")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportTemplateHeader;
